import { useState } from "react";
import { toast } from "sonner";
import { Phone, Plus, Trash2 } from "lucide-react";

const DURUMLAR = [
  { v: "gorusuldu", l: "Görüşüldü", c: "#2F6E4E" },
  { v: "cevapsiz", l: "Cevapsız", c: "#A63A3A" },
  { v: "mesgul", l: "Meşgul", c: "#B8933F" },
  { v: "taninmiyor", l: "Tanınmıyor", c: "#7C5E9B" },
  { v: "hat_kapali", l: "Hat Kapalı", c: "#8C8377" },
];
const dLabel = (v) => (DURUMLAR.find((d) => d.v === v) || {}).l || v || "-";
const dColor = (v) => (DURUMLAR.find((d) => d.v === v) || {}).c || "#8C8377";
const fmtDT = (d) => (d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-");
const nowLocal = () => new Date().toISOString().slice(0, 16);

export default function BorcluGorusmeleri({ items = [], canAdd, isAdmin, onAdd, onDelete }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ arama_tarihi: nowLocal(), aranan_numara: "", durum: "gorusuldu", notlar: "" });

  const submit = async () => {
    if (!f.arama_tarihi) { toast.error("Arama tarihi zorunlu"); return; }
    setBusy(true);
    try {
      await onAdd({ ...f, arama_tarihi: new Date(f.arama_tarihi).toISOString() });
      setOpen(false);
      setF({ arama_tarihi: nowLocal(), aranan_numara: "", durum: "gorusuldu", notlar: "" });
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-white border border-[#E7DECC] rounded-sm" data-testid="borclu-gorusmeleri">
      <div className="flex items-center justify-between px-4 py-3 border-b border-[#E7DECC]">
        <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#2F6E4E]" /><div className="kicker">BORÇLU GÖRÜŞMELERİ</div></div>
        {canAdd && <button onClick={() => setOpen(!open)} data-testid="gorusme-ekle-btn" className="flex items-center gap-1.5 px-3 py-1.5 bg-[#2F6E4E] hover:bg-[#265b40] text-white rounded-sm text-sm font-medium transition-colors duration-150"><Plus className="w-4 h-4" /> Görüşme Ekle</button>}
      </div>
      {open && canAdd && (
        <div className="p-4 border-b border-[#E7DECC] bg-[#F3ECDD]/50 grid grid-cols-1 md:grid-cols-2 gap-3">
          <div><label className="kicker block mb-1.5">ARAMA TARİHİ / SAATİ (kayıt sonrası değiştirilemez)</label><input type="datetime-local" value={f.arama_tarihi} onChange={(e) => setF({ ...f, arama_tarihi: e.target.value })} data-testid="gorusme-tarih" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm bg-white focus:outline-none focus:border-[#2F6E4E]" /></div>
          <div><label className="kicker block mb-1.5">ARANAN NUMARA</label><input value={f.aranan_numara} onChange={(e) => setF({ ...f, aranan_numara: e.target.value })} data-testid="gorusme-numara" placeholder="05xx xxx xx xx" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm bg-white focus:outline-none focus:border-[#2F6E4E]" /></div>
          <div><label className="kicker block mb-1.5">DURUM</label><select value={f.durum} onChange={(e) => setF({ ...f, durum: e.target.value })} data-testid="gorusme-durum" className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm bg-white">{DURUMLAR.map((d) => <option key={d.v} value={d.v}>{d.l}</option>)}</select></div>
          <div className="md:col-span-2"><label className="kicker block mb-1.5">ARAMA NOTLARI</label><textarea value={f.notlar} onChange={(e) => setF({ ...f, notlar: e.target.value })} data-testid="gorusme-notlar" rows={2} className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm bg-white focus:outline-none focus:border-[#2F6E4E]" /></div>
          <div className="md:col-span-2 flex justify-end"><button onClick={submit} disabled={busy} data-testid="gorusme-kaydet" className="px-4 py-2 bg-[#26231E] text-white rounded-sm text-sm font-medium disabled:opacity-50">{busy ? "Kaydediliyor..." : "Kaydet"}</button></div>
        </div>
      )}
      <table className="w-full text-sm">
        <thead><tr className="border-b border-[#E7DECC] bg-[#F3ECDD]">
          <th className="px-4 py-2.5 kicker text-left">Arama Tarihi</th>
          <th className="px-4 py-2.5 kicker text-left">Aranan No</th>
          <th className="px-4 py-2.5 kicker text-left">Durum</th>
          <th className="px-4 py-2.5 kicker text-left">Notlar</th>
          <th className="px-4 py-2.5 kicker text-left">Ekleyen</th>
          <th className="px-4 py-2.5 kicker text-right">İşlem</th>
        </tr></thead>
        <tbody>
          {items.length === 0 ? (
            <tr><td colSpan={6} className="px-4 py-6 text-center text-[#8C8377]">Henüz görüşme kaydı yok.</td></tr>
          ) : items.map((g, i) => (
            <tr key={g.id || i} className={`border-b border-[#E7DECC] ${i % 2 ? "bg-[#F3ECDD]/60" : ""}`} data-testid={`gorusme-row-${i}`}>
              <td className="px-4 py-2 tabular-nums whitespace-nowrap">{fmtDT(g.arama_tarihi)}</td>
              <td className="px-4 py-2 whitespace-nowrap">{g.aranan_numara || "-"}</td>
              <td className="px-4 py-2"><span className="px-2 py-0.5 rounded-sm text-xs font-semibold" style={{ backgroundColor: `${dColor(g.durum)}1a`, color: dColor(g.durum) }}>{dLabel(g.durum)}</span></td>
              <td className="px-4 py-2 text-[#8C8377] max-w-[280px]">{g.notlar || "-"}</td>
              <td className="px-4 py-2 whitespace-nowrap">{g.ekleyen_ad || g.ekleyen_email || "-"}</td>
              <td className="px-4 py-2 text-right">{isAdmin && <button onClick={() => onDelete(g.id)} data-testid={`gorusme-del-${i}`} className="p-1.5 text-[#8C8377] hover:text-[#A63A3A] rounded-sm transition-colors duration-150"><Trash2 className="w-4 h-4" /></button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
